import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const UKFlagIcon: FC<IconProps> = ({ width = 21, height = 15, ...rest }) => (
  <Icon type="UKFlag" width={width} height={height} alt="UKFlagIcon" {...rest} />
)
